import * as React from "react";
import Transformer from "src/common/Transformer";
import { SubscriberEditComponent } from "./SubscriberComponent";
import { StatusEnum } from "src/common/enum";
import { Edit, SimpleForm } from "src/enterprise/ra-rbac";
import { Grid } from "@mui/material";
import {
  ReferenceInput,
  SelectInput,
  TextInput,
  AutocompleteInput,
  required
} from "react-admin";

export const SubscriberEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: [
        "id",
        "createdAt",
        "createdBy",
      ],
      update: {
        user: data.user.id,
        product: data.product.id,
      },
    });

    return data;
  };

  return (
    <Edit
      component={SubscriberEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} md={6}>
            <TextInput disabled source="id" />
          </Grid>
          <Grid item sm={12} md={6}>
            <SelectInput
              validate={required()}
              source="status"
              choices={StatusEnum}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <TextInput
              source="email"
              label="Email"
              disabled
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <ReferenceInput
              source="user.id"
              reference="admin/users"
            >
              <AutocompleteInput
                optionText={(record) => record.first_name+" "+record.last_name+" ("+record.email+")"}
                size="small"
                label="User"
              />
            </ReferenceInput>
          </Grid>
          <Grid item sm={12} md={6}>
            <TextInput
              source="quantity"
              label="Quantity"
              disabled
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <ReferenceInput
              source="product.id"
              reference="admin/products"
            >
              <AutocompleteInput
                optionText={(record) => {
                  return record.name + " " + record.sku;
                }}                
                validate={required()}
                disabled
                size="small"
                label="Product"
              />
            </ReferenceInput>
          </Grid>
          <Grid item sm={12} md={6}>
            <TextInput
              disabled
              source="note"
              label="note"
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
